import React from "react";
import Grid from "@mui/material/Grid";
import LogoAuth from "../assets/images/LogoAuth.png";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import LanguageSelect from "../components/LanguageSelect";

function AuthLayout(props) {
  const routesWithoutSidebar = [`/register`];
  const routesForConfirmation = [`/confirm-user`];
  const { pathname } = useLocation();
  const shouldInclude = !routesWithoutSidebar.includes(pathname);
  const shouldConfirm = routesForConfirmation.includes(pathname);
  const { t } = useTranslation();

  const smUp = useMediaQuery((theme) => theme.breakpoints.up("sm"), {
    defaultMatches: true,
    noSsr: false,
  });

  const mdUp = useMediaQuery((theme) => theme.breakpoints.up("md"), {
    defaultMatches: true,
    noSsr: false,
  });

  const xsUp = useMediaQuery((theme) => theme.breakpoints.up("xs"), {
    defaultMatches: true,
    noSsr: false,
  });

  return (
    <Grid container>
      {smUp && (
        <Grid item xs={5}>
          <div className="auth-backgound-image">
            {/* <img
              alt="Nothing"
              style={{ paddingLeft: "60px", height: "20vh" }}
              src={LogoAuth}
            ></img> */}
            <div
              style={{
                // marginBottom: "40vh",
                padding: "0px 60px",
                marginTop: mdUp ? "-77%" : "0px",
                width: "80%",
              }}
            >
              <p
                style={{
                  color: "#FFFFFF",
                  display: "block",
                  fontSize: mdUp ? "44px" : "34px",
                }}
                className="auth-backgound-title"
              >
                Welcome to Cytailor partner experience
              </p>
            </div>
          </div>
        </Grid>
      )}
      <Grid item xs={12} sm={7}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <div style={{ padding: xsUp ? "30px 50px" : "30px 70px" }}>
            <LanguageSelect />
          </div> */}
          {shouldInclude ? (
            <div style={{ padding: xsUp ? "30px 50px" : "30px 70px" }}>
              <span style={{ color: "#818181" }}>{t("new_user")}?&nbsp;</span>
              <Link
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  fontWeight: "600",
                }}
                to="/register"
              >
                {" "}
                {t("create_account")}
              </Link>
            </div>
          ) : (
            <div style={{ padding: xsUp ? "30px 60px" : "30px 70px" }}>
              <span style={{ color: "#818181" }}>{t("old_user")}? &nbsp;</span>
              <Link
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  fontWeight: "600",
                }}
                to="/login"
              >
                {" "}
                {t("log_in")}
              </Link>
            </div>
          )}
        </div>

        <div
          style={{
            height: "calc(100vh - 125px)",
            padding: mdUp ? "20px 100px" : "20px 50px",
            overflow: "auto",
          }}
        >
          {props.children}
        </div>
      </Grid>
    </Grid>
  );
}

export default AuthLayout;
